module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/th/1-2452171360cbc58c7adb1b6298506d9e.jpg";